import { Filter } from '@/interfaces/filter.interface'
import { APICarrierPolicy } from '@/models/api/carrier-policy.model'
import { CarrierPoliciesServices } from '@/services/modules/carriers-policies.service'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module
export default class CarrierPoliciesStore extends VuexModule {
    carrierpolicies: object[] = []
    carrierpoliciesPaginate: object[] = []
    carrierpolicyForm: object|null = null

    @Mutation
    updateCarrierPolicies (newCarrierPolicies: object[]) {
        this.carrierpolicies = newCarrierPolicies
    }

    @Mutation
    updateCarrierPoliciesPaginate (newCarrierPolicies: object[]) {
        this.carrierpoliciesPaginate = newCarrierPolicies
    }

    @Mutation
    updateCarrierPolicy (newCarrierPolicy: object) {
        this.carrierpolicyForm = newCarrierPolicy
    }

    @Action
    getCarrierPolicies () {
        return new Promise((resolve) => {
            CarrierPoliciesServices.getCarrierPolicies()
                .then(resp => {
                    store.commit('updateCarrierPolicies', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getCarrierPoliciesPaginate (params: { page: number; filters?: Filter[]; limit: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = {
                page: params.page,
                limit: params.limit,
                sortBy: params.sortBy,
                sort: params.sort
            }
            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            CarrierPoliciesServices.getCarrierPoliciesPaginate(newParams)
                .then(resp => {
                    store.commit('updateCarrierPoliciesPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getCarrierPoliciesById (id: number) {
        return new Promise((resolve) => {
            CarrierPoliciesServices.getCarrierPoliciesById(id)
                .then(resp => {
                    store.commit('updateCarrierPolicy', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editCarrierPolicies (params: APICarrierPolicy) {
        params = new APICarrierPolicy(params)

        return new Promise((resolve) => {
            if (!(params instanceof APICarrierPolicy)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            CarrierPoliciesServices.editCarrierPolicies(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createCarrierPolicies (params: APICarrierPolicy) {
        params = new APICarrierPolicy(params)

        params.carrierPolicyEnabled = 1

        return new Promise((resolve) => {
            if (!(params instanceof APICarrierPolicy)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            CarrierPoliciesServices.createCarrierPolicies(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteCarrierPolicies (id: number) {
        return new Promise((resolve) => {
            CarrierPoliciesServices.deleteCarrierPolicies(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    restoreCarrierPolicies (id: number) {
        return new Promise((resolve) => {
            CarrierPoliciesServices.restoreCarrierPolicies(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
